<div class="profile-popup-overlay" *ngIf="show" (click)="onClose()">
  <div class="profile-popup" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2>Profile</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="popup-content">
      <div class="section basic-details">
        <h3>Basic Details</h3>
        <div class="detail-row" *ngIf="userDetails?.fullName">
          <label>Name:</label>
          <span>{{ userDetails?.fullName }}</span>
        </div>
        <div class="detail-row">
          <label>Email:</label>
          <span>{{ userDetails?.email }}</span>
        </div>
        <div class="detail-row">
          <label>Role:</label>
          <span>{{ userDetails?.role }}</span>
        </div>
        <div class="detail-row">
          <label>Member Since:</label>
          <span>{{ userDetails?.memberSince }}</span>
        </div>
      </div>

      <div class="section subscription">
        <h3>Subscription</h3>
        <div class="plan-details" *ngIf="subscriptionInfo?.subscribed">
          <div class="plan-info">
            <div class="plan-details-row">
              <span class="plan-name">{{ subscriptionInfo.planName }}</span>
              <span class="plan-price">{{ subscriptionInfo.billingCycle | titlecase }}</span>
            </div>
            <div class="plan-expiry-row" *ngIf="subscriptionInfo.planExpiry">
              <span class="expiry-label">Expires:</span>
              <span class="expiry-date">{{ subscriptionInfo.planExpiry | date:'MMM dd, yyyy' }}</span>
            </div>
          </div>
          <div class="credits-info">
            <div class="credit-item">
              <div class="credit-header">
                <label>Email Credits</label>
                <div class="credit-numbers">
                  <span class="remaining">{{ subscriptionInfo.availableEmailCredits }}</span>
                  <span class="separator">/</span>
                  <span class="maximum">{{ subscriptionInfo.maxEmails }}</span>
                </div>
              </div>
              <div class="progress-bar">
                <div class="progress"
                  [style.width.%]="(subscriptionInfo.availableEmailCredits / subscriptionInfo.maxEmails) * 100"></div>
              </div>
            </div>
            <div class="credit-item">
              <div class="credit-header">
                <label>Contact Credits</label>
                <div class="credit-numbers">
                  <span class="remaining">{{ subscriptionInfo.availableContactCredits }}</span>
                  <span class="separator">/</span>
                  <span class="maximum">{{ subscriptionInfo.maxContacts }}</span>
                </div>
              </div>
              <div class="progress-bar">
                <div class="progress"
                  [style.width.%]="(subscriptionInfo.availableContactCredits / subscriptionInfo.maxContacts) * 100">
                </div>
              </div>
            </div>
            <div class="credit-item">
              <div class="credit-header">
                <label>AI Co-Pilot Campaign Credits</label>
                <div class="credit-numbers">
                  <span class="remaining">{{ subscriptionInfo.availableAgentCampaignCredits }}</span>
                  <span class="separator">/</span>
                  <span class="maximum">{{ subscriptionInfo.maxAgentCampaignCredits }}</span>
                </div>
              </div>
              <div class="progress-bar">
                <div class="progress"
                  [style.width.%]="(subscriptionInfo.availableAgentCampaignCredits / subscriptionInfo.maxAgentCampaignCredits) * 100">
                </div>
              </div>
            </div>
            <div class="credit-item">
              <div class="credit-header">
                <label>AI Research Queries</label>
                <div class="credit-numbers">
                  <span class="remaining">{{ subscriptionInfo.availableAgentResearchCredits }}</span>
                  <span class="separator">/</span>
                  <span class="maximum">{{ subscriptionInfo.maxAgentResearchCredits }}</span>
                </div>
              </div>
              <div class="progress-bar">
                <div class="progress"
                  [style.width.%]="(subscriptionInfo.availableAgentResearchCredits / subscriptionInfo.maxAgentResearchCredits) * 100">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="plan-details not-subscribed" *ngIf="!subscriptionInfo?.subscribed">
          <div class="plan-info">
            <div class="subscription-status">
              <div class="status-icon">⚠️</div>
              <div class="status-text">
                <h4>Not subscribed Yet</h4>
                <p>Subscribe to unlock all features and benefits</p>
              </div>
            </div>
            <button class="subscribe-btn" (click)="onSubscribe()">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>